'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  var cashtagsOnly = [],
      cashtagsWithIndices = (0, _extractCashtagsWithIndices2.default)(text);

  for (var i = 0; i < cashtagsWithIndices.length; i++) {
    cashtagsOnly.push(cashtagsWithIndices[i].cashtag);
  }

  return cashtagsOnly;
};

var _extractCashtagsWithIndices = require('./extractCashtagsWithIndices');

var _extractCashtagsWithIndices2 = _interopRequireDefault(_extractCashtagsWithIndices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];